import React from 'react';
import GatsbyImage from 'gatsby-image';
import { snakeCase } from 'lodash';

export default function TestimonialBlock({ testimonial }) {
  const {
    name,
    text,
    author_name: authorName,
    author_image: authorImage,
    author_profession: authorProfession
  } = testimonial;
  return (
    <div id={snakeCase(name)} className='Testimonial-section-body mb-5'>
      <div className="card card-body shadow-sm flex-row py-4">
        <GatsbyImage
          className="avatar avatar-lg"
          fixed={authorImage.localFile.sharp.fixed}
        />
        <div className="ml-3">
          <blockquote className="blockquote blockquote-marks pt-0">
            <p className="mb-0">{text}</p>
          </blockquote>
          <div className="avatar-author d-block" style={{ paddingLeft: '3rem', paddingRight: '3rem'}}>
            <h6>{authorName}</h6>
            <span>{authorProfession}</span>
          </div>
        </div>
      </div>
    </div>
  );
}